import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { campaignLogin } from "./schema/auth/campaign-login";
import { sendMagicLink } from "./schema/auth/send-magic-link";
import { verifyMagicLink } from "./schema/auth/verify-magic-link";
import { getCampaignById } from "./schema/campaign/get-campaign-by-id";
import { getCampaignBySlug } from "./schema/campaign/get-campaign-by-slug";
import { addToCart } from "./schema/cart/add-to-cart";
import { cancelCheckout } from "./schema/cart/cancel-checkout";
import { clearCart } from "./schema/cart/clear-cart";
import { getCart } from "./schema/cart/get-cart";
import { removeFromCart } from "./schema/cart/remove-from-cart";
import { updateCartItem } from "./schema/cart/update-cart-item";
import { createMarketplaceCheckoutSession } from "./schema/create-marketplace-checkout-session";
import { doBulkPurchase } from "./schema/do-bulk-purchase";
import { getHealthCheck } from "./schema/get-health-check";
import { getMarketplaceProducts } from "./schema/get-marketplace-products";
import { getMarketplaceProductsByVendor } from "./schema/get-marketplace-products-by-vendor";
import { getMarketplaceVendorCounts } from "./schema/get-marketplace-vendor-counts";
import { getMarketplaceVendors } from "./schema/get-marketplace-vendors";
import { getMessage } from "./schema/get-message";
import { getProductDetails } from "./schema/get-product-details";

const authEndpoints = { campaignLogin, sendMagicLink, verifyMagicLink };
const campaignEndpoints = { getCampaignBySlug, getCampaignById };
const healthEndpoints = { getHealthCheck, getMessage };
const cartEndpoints = {
  getCart,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart,
  cancelCheckout,
};
const marketplaceEndpoints = {
  getMarketplaceProducts,
  getMarketplaceProductsByVendor,
  getMarketplaceVendors,
  getMarketplaceVendorCounts,
  getProductDetails,
  createMarketplaceCheckoutSession,
  doBulkPurchase,
};
export const rpcDefinition = {
  ...authEndpoints,
  ...campaignEndpoints,
  ...healthEndpoints,
  ...cartEndpoints,
  ...marketplaceEndpoints,
};

export type MarketplaceRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
